import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Template_3.css";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import DefaultData from "../../CompanyData/DefaultData";

const Template_3_Packages = ({ onEnquireClick }) => {
  const companyId = DefaultData.DEFAULTCOMPANYID;
  const [packages, setPackages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const GetPackages = async () => {
      setIsLoading(true);
      try {
        const response = await apiService.getAll(
          `${config.GETPACKAGEBYCOMAPANYID}/${companyId}?type=Holiday`
        );
        setPackages(response.data);
      } catch (error) {
        console.error("Failed to fetch experiences:", error);
      } finally {
        setIsLoading(false);
      }
    };
    GetPackages();
  }, [companyId]);

  return (
    <section className="Template_3 section Template_3 featured-experiences">
      <div className="Template_3 container">
        <div className="Template_3 section-title">
          <h2>Bespoke Experiences</h2>
          <p>Tailored journeys for the sophisticated traveler</p>
        </div>

        {isLoading ? (
          <div className="Template_3 loading">Preparing experiences...</div>
        ) : packages.length === 0 ? (
          <div className="Template_3 no-data">
            No experiences currently available
          </div>
        ) : (
          <div className="Template_3 experiences-list">
            {packages.slice(0, 6).map((pkg) => (
              <div
                key={pkg.packageId}
                className="Template_3 experience-card"
                onClick={() =>
                  navigate(`/template_3_packagedetails/${pkg.packageId}`)
                }
              >
                <div className="Template_3 experience-image">
                  <img src={pkg.imageSrc} alt={pkg.packageName} />
                </div>
                <div className="Template_3 experience-content">
                  <h3>{pkg.packageName}</h3>
                  <div className="Template_3 experience-meta">
                    <span>
                      <i className="fas fa-clock"></i> {pkg.duration}
                    </span>
                    <span>
                      <i className="fas fa-user-friends"></i> {pkg.noOfPersons}
                    </span>
                  </div>
                  <div className="Template_3 experience-price">
                    {pkg.price ? `INR ${pkg.price}` : "Inquire for rates"}
                  </div>
                  <button
                    className="Template_3 inquire-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      onEnquireClick(pkg);
                    }}
                  >
                    Inquire
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Template_3_Packages;
